import React, { FC } from 'react';
import { LOGIN } from '../../routes';
import "./Logout.css";

export const Logout: FC = () => {
  const ssoLoginUrl = window.localStorage.getItem('ssoLoginUrl');

  const fullLoginUrl = ssoLoginUrl
    ? `${ssoLoginUrl}${window.location.origin}${LOGIN}`
    : null;

  return (
    <div className="logout-container">
      <div className="logout-card">
        <h1>You’ve signed out</h1>
        <p>
          You have successfully logged out of the application.
          For your security, please logout from the corporate ID provider and close your browser if you’re on a shared device.
        </p>

        <div className="logout-actions">
          {fullLoginUrl && (
            <a
              className="button-primary"
              href={fullLoginUrl}
            >
              Sign in again
            </a>
          )}

          <div>
            <a className="link-secondary" href="https://www.cdergroup.co.uk/" >
              Go to CDER Group website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};